import React from 'react';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { Form, Input, Button, Select, ColorPicker } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import {SortableCard} from "./SortableCard";
import {DragHandle} from "./DndTable";

const { Option } = Select;

const MobileWorkflowView = ({
                              workFlow,
                              handleWorkFlowChange,
                              languageMap,
                              different,
                              permissionCurrentUser,
                              stageWorkFlowOption,
                              handleInputClick,
                              handleDelete
                            }) => {
  return (
      <DndContext
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={({ active, over }) => {
            if (active.id !== over?.id) {
              const activeIndex = workFlow.findIndex((item) => item.key === active.id);
              const overIndex = workFlow.findIndex((item) => item.key === over?.id);
              const newWorkFlow = arrayMove(workFlow, activeIndex, overIndex);
              handleWorkFlowChange(newWorkFlow);
            }
          }}
      >
        <SortableContext
            items={workFlow.map((item) => item.key)}
            strategy={verticalListSortingStrategy}
        >
          <div style={{ padding: '16px', paddingBottom: '100px', background: '#fafafa' }}>
            {workFlow.map((record) => (
                <SortableCard
                    key={record.key}
                    id={record.key}
                    style={{
                      marginBottom: '16px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                      border: '1px solid #e0e0e0',
                      background: '#fff',
                      overflow: 'hidden',
                    }}
                    title={
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <Form.Item
                            name={['progressRequests', record.key, 'krName']}
                            initialValue={record.krName}
                            rules={[
                              {
                                required: true,
                                message: languageMap?.["project.management.require.nameWorkflow"] ?? "Require name"
                              },
                              {
                                max: 100,
                                message: 'Name cannot exceed 100 characters!',
                              },
                            ]}
                            noStyle
                        >
                          <Input
                              disabled={different.type === 'UPDATED' && !permissionCurrentUser?.includes('U')}
                              onClick={() => handleInputClick(record.key)}
                              placeholder={languageMap?.['project.management.workFlow.plahe'] ?? 'Workflow name'}
                              bordered={false}
                              style={{
                                padding: 0,
                                fontWeight: 600,
                                fontSize: '16px',
                              }}
                          />
                        </Form.Item>
                        <div style={{ marginLeft: 'auto' }}>
                          <Button
                              key="delete"
                              onClick={() => handleDelete(record.key)}
                              type="text"
                              disabled={!record.newData}
                              icon={<DeleteOutlined />}
                              style={{ color: '#ff4d4f' }}
                          />
                        </div>
                      </div>
                    }
                >
                  <div style={{ padding: '0 16px 16px' }}>
                    {/* Row 2: Select + Color */}
                    <Form.Item
                        name={['progressRequests', record.key, 'sortSequence']}
                        initialValue={workFlow.find(item => item.key === record.key)?.sortSequence}
                        noStyle
                        hidden
                    >
                      <DragHandle/>
                    </Form.Item>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'nowrap' }}>
                      {/* Select (Stage) */}
                      <Form.Item
                          label={<span style={{ fontWeight: 500, fontSize: 14 }}>{languageMap?.["project.management.workFlow.stage"] ?? 'Stage'}</span>}
                          name={['progressRequests', record.key, 'segmentCode']}
                          rules={[{
                            required: true,
                            message: languageMap?.["project.management.require.stageWorklflow"] ?? 'Stage is require!',
                          }]}
                          style={{ flex: 1, marginBottom: 0 }}
                      >
                        <Select
                            disabled={different.type === 'UPDATED' && !permissionCurrentUser?.includes('U')}
                            placeholder={languageMap?.["project.management.workFlow.select"] ?? "Select stage"}
                            style={{ width: '100%' }}
                        >
                          {stageWorkFlowOption.map((item) => (
                              <Option value={item.code} key={item.code}>
                                {languageMap?.[`project.management.workFlow.${item.enName.toLowerCase().replace(/ /g, "_")}`] ?? item.enName}
                              </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {/* Color Picker */}
                      <Form.Item
                          label={<span style={{ fontWeight: 500, fontSize: 14 }}>{languageMap?.["project.management.workFlow.color"] ?? 'Color'}</span>}
                          name={['progressRequests', record.key, 'color']}
                          initialValue="#1677ff"
                          getValueFromEvent={(e) => e?.toHexString()}
                          style={{ flex: 1, marginBottom: 0 }}
                      >
                        <ColorPicker
                            disabled={different.type === 'UPDATED' && !permissionCurrentUser?.includes('U')}
                            size="small"
                            showText
                            style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </div>

                    {/* Hidden fields */}
                    <Form.Item name={['progressRequests', record.key, 'projectProgressCode']} noStyle hidden />
                    <Form.Item name={['progressRequests', record.key, 'sortSequence']} noStyle hidden />
                    <Form.Item name={['progressRequests', record.key, 'enName']} noStyle hidden />
                    <Form.Item name={['progressRequests', record.key, 'vnName']} noStyle hidden />
                  </div>
                </SortableCard>
            ))}
          </div>
        </SortableContext>
      </DndContext>
  );
};

export default MobileWorkflowView;